import { styled as styled2 } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import {
	Z_INDEX,
	CARD_LIST_RADIUS,
	COLUMN_HEADER_HEIGHT,
	BOARD_VIEW_COLUMNS_OFFSET,
} from '../../../../common/constants';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NoTransitionsAvailableMessageContainer = styled2.div<{
	featureView: 'jwm-board' | 'jwm-board-embed';
}>({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.danger', colors.R50),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	borderRadius: `${CARD_LIST_RADIUS}px`,
	position: 'sticky',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	top: `${COLUMN_HEADER_HEIGHT}px`,
	height: '100%',
	alignItems: 'center',
	justifyContent: 'center',
	padding: `0 ${token('space.200', '16px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	border: `2px solid ${token('color.border.danger', colors.R100)}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	zIndex: Z_INDEX.transitionZones,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	maxHeight: ({ featureView }) => `min(
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
                  calc(100% - ${COLUMN_HEADER_HEIGHT + 4}px),
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
                  calc(100vh - ${BOARD_VIEW_COLUMNS_OFFSET[featureView]}px)
              )`,
});
